export default __webpack_public_path__ + "static/media/demo.39784f58.mp4";